import React from 'react';
import { FolderIcon, StarIcon } from 'lucide-react';
import { ItemMenu, type ItemActions } from './ItemMenu';
import { FILE_TYPE_META } from '../../utils/fileTypes';
import { folderStats, isFile } from '../../utils/fileTree';
import { formatDateTime, formatSize } from '../../utils/format';
import type { FsNode } from '../../types/files';
interface FileGridProps {
  nodes: FsNode[];
  rows: FsNode[];
  selectedIds: string[];
  isTrash: boolean;
  actions: ItemActions;
  onToggleRow: (id: string) => void;
  onDragStart: (node: FsNode) => void;
  onDragEnd: () => void;
  onDropOnFolder: (targetId: string) => void;
  draggingIds: string[];
}
export function FileGrid({
  nodes,
  rows,
  selectedIds,
  isTrash,
  actions,
  onToggleRow,
  onDragStart,
  onDragEnd,
  onDropOnFolder,
  draggingIds
}: FileGridProps) {
  return <ul className="grid grid-cols-2 gap-3 p-4 sm:grid-cols-3 xl:grid-cols-4" data-id="element-60" data-mp="u81ecsgn5wjy">
      {rows.map(node => {
      const isSelected = selectedIds.includes(node.id);
      const folder = node.kind === 'folder';
      const stats = folder ? folderStats(nodes, node.id) : null;
      const meta = isFile(node) ? FILE_TYPE_META[node.type] : null;
      const Icon = meta?.icon ?? FolderIcon;
      const canDrop = folder && draggingIds.length > 0 && !draggingIds.includes(node.id);
      return <li key={node.id} data-id="element-61" data-mp="30ndwbposw6q7">
            <div draggable={!isTrash} onDragStart={() => onDragStart(node)} onDragEnd={onDragEnd} onDragOver={event => {
          if (canDrop) event.preventDefault();
        }} onDrop={event => {
          if (!canDrop) return;
          event.preventDefault();
          onDropOnFolder(node.id);
        }} onClick={() => actions.onOpen(node)} className={['flex h-full cursor-pointer flex-col overflow-hidden rounded border transition', isSelected ? 'border-[#0176d3] bg-[#eef4ff] ring-1 ring-[#0176d3]' : 'border-slate-200 bg-white hover:border-slate-300 hover:shadow-sm'].join(' ')} data-id="element-62" data-mp="2lwn44gjar5mk">
              <div className="relative flex h-28 items-center justify-center bg-slate-50" data-id="element-63" data-mp="4p51dlgqtgjl">
                {isFile(node) && node.thumbnailUrl ? <img src={node.thumbnailUrl} alt={node.name} className="h-full w-full object-cover" data-id="element-64" data-mp="3vsjz1dr4z0f3" /> : <Icon className={['h-10 w-10', folder ? 'text-[#0176d3]' : meta?.iconClass ?? ''].join(' ')} aria-hidden="true" data-id="element-65" data-mp="nel3gd82th24" />}
                <input type="checkbox" checked={isSelected} onClick={event => event.stopPropagation()} onChange={() => onToggleRow(node.id)} aria-label={`Select ${node.name}`} className="absolute left-2 top-2 h-4 w-4 rounded border-slate-400 bg-white text-[#0176d3] focus:ring-[#0176d3]" data-id="element-66" data-mp="3863mzzzu1d06" />
                {node.starred && <StarIcon className="absolute right-2 top-2 h-4 w-4 fill-amber-400 text-amber-500" aria-label="Starred" data-id="element-67" data-mp="37qx2qwgenwp8" />}
              </div>
              <div className="flex flex-1 items-start gap-1 p-3" data-id="element-68" data-mp="3gq21o3vvps1x">
                <div className="min-w-0 flex-1" data-id="element-69" data-mp="3lqpt2qo0sawo">
                  <p className="truncate text-sm font-medium text-slate-900" data-id="element-70" data-mp="3lr7vk519zld1">
                    {node.name}
                  </p>
                  <p className="mt-0.5 truncate text-xs text-slate-500" data-id="element-71" data-mp="1rcf2acnv76o9">
                    {folder ? `${stats?.fileCount ?? 0} files · ${formatSize(stats?.sizeKb ?? 0)}` : `${formatSize(node.sizeKb)} · ${formatDateTime(node.modifiedAt)}`}
                  </p>
                </div>
                <div onClick={event => event.stopPropagation()} data-id="element-72" data-mp="3hubxhkmfxur9">
                  <ItemMenu node={node} isTrash={isTrash} actions={actions} data-id="element-73" data-mp="3vtbkyoy7w3lu" />
                </div>
              </div>
            </div>
          </li>;
    })}
    </ul>;
}